<template>
  <div>
    <van-nav-bar :border="false" :fixed="true" :placeholder="true" style="background-color: rgb(9, 31, 48) !important;">
      <template #left>
        <div
          style="
            display: inline;
            height: 46px;
            padding-top: 10px;
            margin-right: 8px;
          "
        >
          <img :src="safeWapConfig.logo" style="height: 24px" />
        </div>
      </template>
      <template #right>
        <van-icon
          name="contact-o"
          size="20"
          style="color: #00b5c9 !important; margin-right: 15px"
          v-if="isLogin"
          @click="toMember"
        />
        <van-popover
          v-if="actions.length > 0"
          v-model="showPopover"
          theme="dark"
          trigger="click"
          placement="bottom-end"
        >
          <ul>
            <li
              @click="changeLang(item)"
              v-for="(item, index) in actions"
              :key="index"
              class="lang-item-box"
            >
              <div style="float: left; height: 30px; line-height: 30px">
                {{ item.language_name }}
              </div>
              <div style="float: right; height: 30px; line-height: 30px">
                <img
                  :src="require('@/assets/lang/' + item.file_name + '.png')"
                  style="width: 17px; height: 13px"
                />
              </div>
            </li>
          </ul>
          <template #reference>
            <li class="lang-item" v-if="langval && langval.length > 0">
              <div class="lang-item-icon">
                <img
                  v-if="langval && langval != 'zh-CN'"
                  :src="require('@/assets/lang/' + langval + '.png')"
                  style="width: auto; height: 18px; margin-top: 4px"
                />
              </div>
            </li>
            <li class="lang-item" v-else>
              <div class="lang-item-icon">
                <svg-icon icon-class="lang" style="font-size: 24px" />
              </div>
            </li>
          </template>
        </van-popover>
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
import { setTokenbyName, getTokenbyName, TokenLangKey,getToken } from '@/utils/cookies'
export default {
  name: 'HomeHeader',
  inject: ['app'],
  computed: {
    safeWapConfig () {
      return this.app.wapConfig || {}
    }
  },
  data () {
    return {
      showPopover: false,
      actions: [],
      langval: null,
      isdefault: null
    }
  },
  mounted () {
    this.langval = getTokenbyName(TokenLangKey)
    this.getLangList()
  },
  methods: {
    toMember(){
      this.$emit('open-left')
    },
    isLogin(){
      return getToken()
    },
    getlangName (val) {
      let reuslt = val
      this.actions.forEach(item => {
        if (val == item.file_name) {
          reuslt = item.language_name
        }
      })
      return reuslt
    },
    async changeLang (item) {
      this.showPopover = false
      setTokenbyName(TokenLangKey, item.file_name)
      await this.$http({
        method: 'get',
        url: 'setLang',
        data: { lang: item.file_name }
      }).then(() => {})
      location.reload()
    },
    async getLangList () {
      await this.$http({
        method: 'get',
        url: 'getLangList'
      }).then(res => {
        this.actions = res.data.list
        this.langval = getTokenbyName(TokenLangKey)
        if (!(this.langval && this.langval.length > 0)) {
          this.actions.forEach(element => {
            if (element.is_default == 1) {
              this.langval = element.file_name
              setTokenbyName(TokenLangKey, this.langval)
              location.reload()
            }
          })
        }
      })
    }
  }
}
</script>

<style></style>
